import ReactOnRails from 'react-on-rails/client';
import ContactEditProfilePage from '../../app/ContactEditProfilePage.jsx';

ReactOnRails.register({ContactEditProfilePage});